import { memo } from 'react';
import { string } from 'prop-types';

import styles from './PersonDetailsCard.scss';

const PersonDetailsCard = memo(({ title, name, phone, email, ...props }) => (
  <article className={styles.PersonDetailsCard} {...props}>
    <h4 className={styles.Title}>{title}</h4>
    <p data-testid="PersonFullName">{name}</p>
    <p data-testid="PersonPhone">{phone}</p>
    {email && <p data-testid="PersonEmail">{email}</p>}
  </article>
));

const MemoizedPersonDetailsCard = memo(PersonDetailsCard);

export { MemoizedPersonDetailsCard as PersonDetailsCard };

PersonDetailsCard.propTypes = {
  title: string.isRequired,
  name: string.isRequired,
  phone: string.isRequired,
  email: string,
};
